const OurMission = () => {
  return (
    <div className="app-ourmission-container" id="our-mission">
      <h2 className="ourmission-headText">OUR MISSION</h2>
      <p className="ourmission-paraText">
        Establishing systems and working standards to achieve zero defects and
        commit total customer satisfaction. Manufacturing will be done under
        strict surveillance of quality experts and supervisors, who ensure that
        the quality of products manufactured is maintained thereby delivering
        the high quality and reliable product to our customer.
      </p>
      <p className="ourmission-paraText">
        We use our technical expertise to help our customers to always be in a
        competitive advantage. Our proactive approach to technical issues
        enables our customers to understand and implement cost-effective
        solutions in CNC Laser cutting and SS Fabrication.
      </p>
    </div>
  );
};

export default OurMission;
